module.exports = __webpack_public_path__ + "img/pro-zdIcon3.a2dc857b.png";